
  import { defineComponent, PropType } from 'vue';

  import ArrowDynamic from '@/common/components/redesigned/ArrowDynamic.vue';
  import DynamicIndicator from '@/common/components/redesigned/DynamicIndicator.vue';
  import constants from '@/common/constants';
  import text from '@/common/mixins/text';

  import { TPACochairCountryItem } from '../../store/personalAccount/types';
  import PersonCard from '../PersonCard.vue';

  export default defineComponent({
    name: 'CountryCard',
    components: {
      ArrowDynamic,
      DynamicIndicator,
      PersonCard,
    },
    mixins: [text],
    props: {
      country: {
        type: Object as PropType<TPACochairCountryItem>,
        required: true,
      },
    },
    computed: {
      getSummaryTotalValue() {
        return this.formatNumber(this.country.summary.totalValue / constants.MILLION) == '0,00'
          ? '-'
          : this.formatNumber(this.country.summary.totalValue / constants.MILLION, 1);
      },
    },
    setup() {
      return {};
    },
  });
